export const FIRST_TIME = 'firstTime'
export const USER_REGION = 'userRegion'
export const USER_COUNTRY_CODE = 'userCountryCode'
